import { getStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";

export function getCurrentAccount(): MailboxInfo | null {
    return getStore().currentAccount;
}
